import { __assign } from "tslib";
import { PluginType, isSourceGroupWithOptions, isPluginWithOptions } from "../interfaces";
import deepmerge from "deepmerge";

function runExtractor(source, plugin, options) {
  var newData = plugin({
    source: source.source,
    options: options
  });

  var newSource = __assign({}, source);

  newSource.source.data = __assign(__assign({}, source.source.data), newData);
  return newSource;
}

function runMutation(source, plugin, options) {
  var newContent = plugin({
    source: source.source,
    options: options
  });

  var newSource = __assign({}, source);

  newSource.source.content = newContent;
  return newSource;
}

function runPlugin(source, pluginT, sourceGroupPluginOptions) {
  var pluginOptions = {};
  var plugin;

  if (isPluginWithOptions(pluginT)) {
    pluginOptions = pluginT.options;
    plugin = pluginT.plugin;
  } else {
    plugin = pluginT;
  }

  if (!plugin.sourceTypes || !plugin.sourceTypes.includes(source.source.type)) {
    return source;
  }

  var sourcePlugins = source.pluginsOptions && source.pluginsOptions.find(function (p) {
    return p.name === plugin.name;
  });
  var sourcePluginOptions = sourcePlugins && sourcePlugins.options;
  var options = deepmerge.all([pluginOptions || {}, sourceGroupPluginOptions || {}, sourcePluginOptions || {}]);

  switch (plugin.type) {
    case PluginType.EXTRACTOR:
      return runExtractor(source, plugin.fn, options);

    case PluginType.MUTATION:
      return runMutation(source, plugin.fn, options);

    default:
      return source;
  }
}

function runPluginForGroup(sources, plugin) {
  var sourceGroupPluginOptions = sources.pluginsOptions && sources.pluginsOptions.find(function (p) {
    if (isPluginWithOptions(plugin)) {
      return p.name === plugin.plugin.name;
    }

    return p.name === plugin.name;
  });
  var processedSources = sources.sources.map(function (source) {
    return runPlugin(source, plugin, sourceGroupPluginOptions);
  });
  return __assign(__assign({}, sources), {
    sources: processedSources
  });
}

function runPlugins(sources, plugins) {
  if (!plugins || !plugins.length) {
    return sources;
  }

  var processedSources = sources;
  plugins.map(function (plugin) {
    processedSources = processedSources.map(function (source) {
      if (isSourceGroupWithOptions(source)) {
        return runPluginForGroup(source, plugin);
      }

      return runPlugin(source, plugin);
    });
  });
  return processedSources;
}

export { runPlugins, runPlugin, runPluginForGroup, runMutation, runExtractor };